import { Employee } from '../types';
import { CommonApi, CommonApiMethod } from '.';
const route = 'employee';
const employee: CommonApiMethod = new CommonApi<Employee>(
  route,
  'Сотрудники'
);

export default employee;
